import script from "./record.vue?vue&type=script&setup=true&lang=js"
export * from "./record.vue?vue&type=script&setup=true&lang=js"

import "./record.vue?vue&type=style&index=0&id=48004524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48004524"]])

export default __exports__